import { ScientificAnalysis } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'
import { Nullable } from '@/shared/types/app.types'
import { ColDef, ColGroupDef } from '@ag-grid-community/core'

export interface ScientificAnalysisResultsPanelState {
    toggleSummarySidepanel: boolean
    gridUiComponent: string
    dirty: boolean
    scientificAnalysisUsed: Nullable<ScientificAnalysis>
    columnDefs: Nullable<(ColDef | ColGroupDef)[]>
}
export const initialScientificAnalysisResultsPanelState =
    (): ScientificAnalysisResultsPanelState => ({
        toggleSummarySidepanel: false,
        gridUiComponent: 'uicomponent.scientificanalisis.resultsgrid',
        dirty: false,
        scientificAnalysisUsed: null,
        columnDefs: null
    })
